import Modal from 'antd/lib/modal/Modal';
import React from 'react';

import { Container, Spinner } from './styles';

interface ILoadingFinishModalProps {
  message: string;
}

const LoadingFinishModal: React.FC<ILoadingFinishModalProps> = ({
  message
}) => {
  return (
    <Modal visible={true} closable={false} footer={false}>
      <Container>
        <h2>
          <strong>{message}</strong>
        </h2>
        <Spinner />
      </Container>
    </Modal>
  );
};

export default LoadingFinishModal;
